import { useEffect, useState } from 'react';
import { Radio } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const openPopup = (e, url) => {
  e.preventDefault();
  if (!url) return;
  const w = Math.round(window.screen.availWidth * 0.5);
  const h = Math.round(window.screen.availHeight * 0.6);
  const left = Math.round((window.screen.availWidth - w) / 2);
  const top = Math.round((window.screen.availHeight - h) / 2);
  window.open(url, '_blank', `width=${w},height=${h},left=${left},top=${top},noopener,noreferrer`);
};

export const RSSTicker = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    const load = () => fetch(`${API}/rss/live`)
      .then(r => r.json())
      .then(d => { if (alive && d.items?.length) setItems(d.items); })
      .catch(() => {});
    load();
    const t = setInterval(load, 10 * 60 * 1000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!items.length) return null;
  const reel = [...items, ...items];

  return (
    <div className="w-full bg-black border-y border-red-900/40 overflow-hidden select-none" data-testid="rss-live-ticker">
      <style>{`
        @keyframes rss-marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        .rss-reel { animation: rss-marquee 240s linear infinite; }
        .rss-reel:hover { animation-play-state: paused; }
      `}</style>
      <div className="flex items-stretch h-9">
        <div className="flex items-center gap-1.5 px-3 bg-red-950/60 border-r border-red-900/40 shrink-0 z-10" data-testid="rss-ticker-label">
          <Radio className="w-3.5 h-3.5 text-red-500 animate-pulse" />
          <span className="text-[10px] font-bold tracking-widest text-red-400 whitespace-nowrap">LIVE WIRE</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="rss-reel flex items-center h-full w-max">
            {reel.map((item, i) => (
              <a key={i} href={item.link} onClick={(e) => openPopup(e, item.link)}
                className="flex items-center gap-2 px-4 whitespace-nowrap text-xs text-slate-400 hover:text-cyan-300 transition-colors"
                data-testid={`rss-ticker-item-${i}`}>
                <span className="text-[9px] text-red-500/80 font-semibold">{item.source}</span>
                <span>{item.title}</span>
                <span className="text-slate-700">•</span>
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="text-center text-[8px] text-slate-700 pb-0.5" data-testid="rss-ticker-disclaimer">
        Live external wire — nothing here is stored in the Library
      </div>
    </div>
  );
};
